import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import Card from "../components/common/Card";

const ResetPassword = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    const new_password = e.target.new_password.value;
    const confirm_new_password = e.target.confirm_new_password.value;

    try {
      await api.post("auth/reset-password-confirm/", {
        uid,
        token,
        new_password,
        confirm_new_password,
      });

      alert("Password reset successful. You can now login.");
      navigate("/login");
    } catch (err) {
      alert(err.message || "Reset failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <h2 className="text-center text-2xl font-bold text-primary-600 mb-4">
          Set New Password
        </h2>

        <form onSubmit={submitHandler} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">New Password</label>
            <input
              type="password"
              name="new_password"
              required
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Confirm Password</label>
            <input
              type="password"
              name="confirm_new_password"
              required
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>

          <button
            className="w-full bg-primary-600 text-white py-2 rounded-lg"
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </Card>
    </div>
  );
};

export default ResetPassword;
